import React from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import { DataGrid } from '@mui/x-data-grid';
import {Box, Grid, Button} from '@material-ui/core';
import {Stack, Snackbar, Alert, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from '@mui/material';
import {OutlinedInput, Select, MenuItem, FormControl } from '@mui/material';
///import Radio from '@mui/material/Radio';
import {MetaTags} from 'react-meta-tags';
import axios from 'axios';
import Cookies from 'js-cookie';
import InputAdornment from '@mui/material/InputAdornment';
import SearchIcon from '@mui/icons-material/Search';
import LinearProgress from '@mui/material/LinearProgress'; 
import Tooltip from '@mui/material/Tooltip';
import Authorization from '../components/Authorization';
import LeadDetails from '../leads/LeadDetails'; 
import AccountDetails from '../accounts/AccountDetails';
// import LeadSave from './LeadSave';
///import LeadSaveEdit from './LeadSaveEdit';
import { useSelector } from 'react-redux';
import {API_URL} from '../utils/EnvVars';
import Header from "../common/HeaderMy";
import '../styles/bizofficer-a.css';
import 'font-awesome/css/font-awesome.min.css';

	var vertical='top',horizontal='center';
  
  export default function Execute() {
	const navigate = useNavigate();
	const location = useLocation();
	Cookies.set('leadPageUrl', 'leads', { expires: new Date(new Date().getTime() + 3600000*24*5) });
	const userObj = useSelector(state => state.userDetails);	
	const isloggedin = Cookies.get('isrwadminloggedin');
	const childRefCaseDetails = React.useRef();
	const childRefAccntDetails = React.useRef();
	const childRefSaveNew = React.useRef();
	///const childRefSaveEdit = React.useRef();
	const childRefAuthorization = React.useRef();
	const [dataLoading, setDataLoading] = React.useState(true);
	const [page, setPage] = React.useState(0);
	const [rowCount, setRowCount] = React.useState(74);
	const pageSize = 100;
	const [privileges, setPrivileges] = React.useState("");
	
	const [type, setType] = React.useState("noselect");
	const [filterType, setFilterType] = React.useState("open");
	const [activityTypeList, setActivityTypeList] = React.useState([]);
	const [filter, setFilter] = React.useState(false);
	const [keyword, setKeyword] = React.useState("");
	const [deleteDialogShow, setDeleteDialogShow] = React.useState(false);
	const [selectedRow, setSelectedRow] = React.useState(0);
	const [caseObj, setCaseObj] = React.useState({});
	const [rows, setRows] = React.useState([]);

	const [severityAlert, setSeverityAlert] = React.useState("error");
	const [showAlert, setShowAlert] = React.useState(false);
	const [alertMessage, setAlertMessage] = React.useState("");

	// check if logged in
	React.useEffect(() => {
		if(!isloggedin){
			navigate('/login');
		}
	}, [isloggedin]);

	const handlePageChange = (newPage) => {
	  setSelectedRow(0);
	  setCaseObj(null);
	  setPage(newPage);
	  setFilter(!filter);
	};

	const columns = [
		// {
		// 	field: "Select",
		// 	headerName: "",
		// 	width: 90,
		// 	sortable: false,
		// 		renderCell: (cellValues) => {
		// 		return (
		// 		  <Radio 
		// 			checked={cellValues.id === selectedRow}
		// 			value={cellValues.id}
		// 			name="radio-buttons"
		// 			inputProps={{ 'aria-label': {cellValues} }}
		// 		  />
		// 		 )
		// 	  }
		//   }, 
		{ field: 'srno', headerName: '#', width: 40 },
		{ field: 'startDateTime', headerName: 'Date/Time', width: 150 },
		{ field: 'status', headerName: 'Status', width: 130 },
		{ field: 'subject', headerName: 'Subject', width: 200, renderCell: (myCell) => {
			return <span>{myCell.row.activityType==='Call'?<><i className="fa fa-phone" style={{fontSize:15}} ></i></>:myCell.row.activityType==='Email'?<><i className="fa fa-envelope" style={{fontSize:15}} ></i></>:myCell.row.activityType==='Meeting'?<><i className="fa fa-clock-o" style={{fontSize:15}} ></i></>:myCell.row.activityType==='WhatsApp'?<><i className="fa fa-whatsapp" style={{fontSize:15}} ></i></>:<><i className="fa fa-globe" style={{fontSize:15}} ></i></>} {myCell.value}</span>
		  }, },
	  	{ field: 'remarks', headerName: 'Remarks', width: 250, renderCell: (params) =>  (
			<Tooltip title={params.value} ><span>{params.value}</span></Tooltip>
		   ), },
		{ field: 'relatedTitle', headerName: 'Related Title', width: 170, renderCell: (params) =>  (
			<Tooltip title={params.value} ><span>{params.value}</span></Tooltip>
		   ), },
		{ field: 'relatedTo', headerName: 'Related To', width: 100, renderCell: (params) =>  (
			<Tooltip title={params.value} ><span>{params.value}</span></Tooltip>
		   ), },   
		{ field: 'priority', headerName: 'Priority', width: 100, renderCell: (params) =>  (
			<Tooltip title={params.value} ><span>{params.value}</span></Tooltip>
		   ), },   
		{ field: 'ownerAlias', headerName: 'Assignee', width: 100, renderCell: (params) =>  (
			<Tooltip title={params.value} ><span>{params.value}</span></Tooltip>
		   ), },   			
	  ];

	React.useEffect(() => {		
		if(userObj && userObj.registerId>0){			
			getApiData();
		}
	}, [userObj, filter, location]);

	async function getApiData(){ 
		  let queryString = '';
		  if(filterType && filterType.length>0){
			queryString += '&filter='+filterType;
		  }else if(location && location.state && location.state.filter){
			queryString += '&filter='+location.state.filter;
			setFilterType(location.state.filter);
		  }
		  if(location && location.state && location.state.startDate){
			queryString += '&startDate='+location.state.startDate+'&endDate='+location.state.endDate;
		  }	
		  if(type && type!=='noselect'){
			queryString += '&activityType='+type;
		  } 
		  let apiUrl=API_URL+'/crm-list-activity?search=1&relatedTo=Lead,Account&minRows='+(page*pageSize)+'&maxRows='+pageSize+'&keyword='+keyword+queryString;
		  let axiosHeader = {
					'Content-Type': 'multipart/mixed',
					'device': 'web',
					'registerId': userObj.registerId,
					'uid': userObj.loginId,
					'fullName': userObj.fullName,
					'token': userObj.token,
			};
			const config = {
				method: 'get',
				url: apiUrl,
				headers: axiosHeader
			}
			await axios(config)
			   .then(response => {
				setDataLoading(false);
				if(response && response.status===200 && response.data && response.data.responseTxt==="success"){  
				 	if(page===0){
						setRowCount(response.data.rowCount);
					}
					setRows(response.data.list);	
					setPrivileges(response.data.privileges);
				}else if(response && response.data && response.data.responseTxt==="invalidtoken"){
					navigate('/invalidtoken');
				}else if(response && response.data && response.data.responseTxt==="NoAuthorization"){
					childRefAuthorization.current.handleClickOpen();
				}
			}).catch((error) => {
				setSeverityAlert("error");
				setShowAlert(true);
				setAlertMessage(""+error);			
				return false;
		  	})	
	}

	React.useEffect(() => {
		if(userObj && userObj.registerId>0){		
			getApiDataMultiple();
		}
	}, [userObj]);

	async function getApiDataMultiple(){
		let axiosHeader = {
		  headers: {
			'Content-Type': 'multipart/mixed',
			'device': 'web',
			'registerId': userObj.registerId,
			'uid': userObj.loginId,
			'fullName': userObj.fullName,
			'token': userObj.token,
		  }
		};

			axios.get(API_URL+'/crm-cache-activity-type', axiosHeader)
			.then(response => {
			if(response && response.data && response.data.responseTxt==="success"){ 
				setActivityTypeList(response.data.list);

			}else if(response && response.data && response.data.responseTxt==="invalidtoken"){
				navigate('/invalidtoken');
			} 		 				
			}).catch((error) => {
				setSeverityAlert("error");
				setShowAlert(true);
				setAlertMessage(""+error);			
				return false;
			})
	}

	
	function saveData(opt){
		if(opt===1){
			setCaseObj(null);
			setSelectedRow(0);
			childRefSaveNew.current.handleClickOpen();
		}else if(opt===2){
			childRefSaveNew.current.handleClickOpen();
			//childRefSaveEdit.current.handleClickOpen();
		}else if(opt===3){
			if(caseObj){
				childRefCaseDetails.current.handleClickOpen();
			}
		}
	}
	
	function deleteData(){
		if(caseObj && userObj.token){
			
			setDeleteDialogShow(false);

			let axiosHeader = {
					headers: {
					'Content-Type': 'multipart/mixed',
					'device': 'web',
					'registerId': userObj.registerId,
					'uid': userObj.loginId,
					'fullName': userObj.fullName,
			  		'token': userObj.token,
				}
			}; 

		  const data = new FormData();
		  data.append('id', caseObj.autoId);
				 
		  axios.post(API_URL+'/crm-delete-leads', data, axiosHeader)
				.then((response) => {
					///console.log("RESPONSE RECEIVED: ", response.data.responseTxt);
				if(response.data.responseTxt==="success"){
					setSeverityAlert("success");
					setShowAlert(true);
					setAlertMessage("Lead has been deleted.");
					setRows(response.data.list);	
					setCaseObj(null);
					setSelectedRow(0);				
					return false;
				}else{
			  		setSeverityAlert("error");
					setShowAlert(true);
					setAlertMessage("This lead could not be deleted.");			
					return false;
				}
			}).catch((error) => {
				///console.log("AXIOS ERROR: ", error);
			})	
		}		
		
	}

	function selectRow(obj){
		if(obj && rows[obj.id-1]){			
			setSelectedRow(rows[obj.id-1].id);
			setCaseObj(rows[obj.id-1]);
		}
	}

	const handleOnCellClick = (obj) => {
		///alert(JSON.stringify(obj));
		if(obj && obj.field==='relatedTitle' ){
			///alert(obj.row.relatedTo);
			if(obj.row.relatedTo==='Lead'){
				setCaseObj(rows[obj.id-1]);
				childRefCaseDetails.current.handleClickOpen();
			}else if(obj.row.relatedTo==='Account'){
				///setCaseObj(rows[obj.id-1]);
				childRefAccntDetails.current.handleClickOpen();
			}
		}	
	};

	function search(){
		setSelectedRow(0);
		setCaseObj(null);
		setPage(0);
		setFilter(!filter);
	}

	function onEnter(event){
		if(event.key === 'Enter'){
			search();
		}
	}

	function handleFilterType(val) {
		setFilterType(val);
		search();
	}
	function handleType(val) {
		setType(val);
		search();
	}
		
	function deleteDialogHide(){
		setDeleteDialogShow(false);
	}

	function hideAlert(){
		setShowAlert(false);
	}

	// function updatedList(list){
	// 	setSelectedRow(0);
	// 	setCaseObj(null);
	// 	setChannelId(0);
	// 	setStatus("noselect");
	// 	setType("noselect");
	// 	setFilterType("noselect");
	// 	setKeyword("");
	// 	setRows(list);
	// }


	
	return (
		<div> 
				<MetaTags>
            		<title>Activities</title>
          		</MetaTags>
				
				<Header hamburger={true} pageTitle="Activities" />
				{dataLoading?<LinearProgress />:null}				
				<Box className='mainBox'>
				    <Box mt={1} mb={1} >
							<Grid container spacing={2}>
								<Grid item md={12} xs={12} >

									<FormControl size='small' style={{width:150,marginRight:4,marginBottom:4,float:'left'}}  >
										<Select
											labelId="demo-simple-select-label"
											id="demo-simple-select"
											value={type}
											onChange={event => handleType(event.target.value)}
										>
											<MenuItem value={'noselect'}>All Activity Type</MenuItem>
											{activityTypeList?activityTypeList.map((myRow,mykey)=>(
												<MenuItem key={'ct'+mykey} value={myRow.activityType}>{myRow.activityType}</MenuItem>
											)):null}
										</Select> 
									</FormControl>

									<FormControl size='small' style={{width:150,marginRight:4,marginBottom:4,float:'left'}}  >
										<Select
											labelId="demo-simple-select-label"
											id="demo-simple-select"
											value={filterType}
											onChange={event => handleFilterType(event.target.value)}
										>
											<MenuItem value={'open'}>To-Do</MenuItem>
											<MenuItem value={'overdue'}>Overdue</MenuItem>
											<MenuItem value={'todayOpen'}>Today Follow-up</MenuItem>
											<MenuItem value={'todayCompleted'}>Today Completed</MenuItem>
											<MenuItem value={'todayCancelled'}>Today Cancelled</MenuItem>
											<MenuItem value={'tomorrow'}>Tomorrow</MenuItem>
											<MenuItem value={'yesterday'}>Yesterday</MenuItem>
											<MenuItem value={'next7Days'}>Next 7 days</MenuItem>
											<MenuItem value={'last7Days'}>Last 7 days</MenuItem>
											<MenuItem value={'thisMonth'}>This month</MenuItem>
											<MenuItem value={'last30Days'}>Last 30 days</MenuItem>											
											{/* <MenuItem value={'selectPeriod'}>Select period</MenuItem> */}
										</Select> 
									</FormControl>

									<FormControl style={{marginRight:4,marginBottom:4,float:'left'}}>
										<OutlinedInput 
										 id="keywordtxt"
										 placeholder="Search"
										 value={keyword}
										 onChange={event => setKeyword(event.target.value)}
										 onKeyPress={(event)=>{onEnter(event)}}
										 size="small"
										 endAdornment={
											  <InputAdornment position="end">
												<SearchIcon />
											  </InputAdornment>
											}
										 />
									</FormControl>

									<Button onClick={() => {search()}} style={{marginTop:1,float:'left',backgroundColor:'#FFF',textTransform: 'none'}} size="small" variant="contained"  >Search</Button>

									<div style={{float:'left'}}>

									<i onClick={()=>{window.location='activities-report'}} title="View Report" className="fa fa-file btncolor" style={{fontSize:30, marginLeft:15, cursor:'pointer'}} />


									{/* {userObj.packageId>1?<>		
										<i onClick={()=>{window.location='leadskanban'}} title="Leads Board" className="fa fa-trello btncolor" style={{fontSize:25, marginLeft:15, cursor:'pointer'}} />
									</>:null}	 */}
										{/* {(privileges && privileges.indexOf("create")>-1)?	
											<i onClick={()=>{saveData(1)}} title="Add New" className="fa fa-plus-circle btncolor" style={{fontSize:25, marginLeft:15, cursor:'pointer'}} />
										:null}	 */}
									{/* {(selectedRow>0 && caseObj && caseObj.autoId>0)?<>
										{(privileges && ((privileges.indexOf("update")>-1 && userObj.userId===caseObj.ownerId) || privileges.indexOf("modifyall")>-1) )?	
											<i onClick={()=>{saveData(2)}} title="Edit" className="fa fa-pencil-square-o btncolor" style={{fontSize:25, marginLeft:15, cursor:'pointer'}} />
										:null}
										{(privileges && privileges.indexOf("delete")>-1)?
											<i onClick={()=>{setDeleteDialogShow(true)}} title="Delete" className="fa fa-trash btncolor" style={{fontSize:25, marginLeft:15, cursor:'pointer'}} />
										:null}
										<i onClick={()=>{saveData(3)}} title="Detail" className="fa fa-info-circle btncolor" style={{fontSize:25, marginLeft:15, cursor:'pointer'}} />
									</>:null} */}

										{/* <i onClick={()=>{window.location='caseskanban'}} title="View Kanban Format" className="fa fa-trello btncolor" style={{fontSize:30, marginLeft:15, cursor:'pointer'}} />
										<i onClick={()=>{window.location='caseskanban'}} title="View Calendar" className="fa fa-calendar btncolor" style={{fontSize:30, marginLeft:15, cursor:'pointer'}} />
										<i onClick={()=>{window.location='caseskanban'}} title="Advance Search" className="fa fa-search btncolor" style={{fontSize:30, marginLeft:15, cursor:'pointer'}} /> */}

									</div>	
								</Grid>
							</Grid>
					</Box>

					<div className="tblReport" style={{height: '78vh', width: '100%' }}>
						<DataGrid
							rows={rows}
							columns={columns}
							pageSize={pageSize}
							rowsPerPageOptions={[pageSize]}
							rowHeight={40}
							rowCount={rowCount}								
							paginationMode="server"
							onPageChange={handlePageChange}
  							loading={dataLoading}
							disableSelectionOnClick															
							style={{fontSize:12}}	
							onRowClick={itm => selectRow(itm)}	
							onCellClick={handleOnCellClick}		
							components={{
								NoRowsOverlay: () => (
								  <Stack height="100%" alignItems="center" justifyContent="center">
									<span style={{color:'#FF0000',fontWeight:'bold'}}>No record found!</span>
								  </Stack>
								)}}	
						/>
					</div>

				</Box>
				
			{/* <LeadSave dataObj={caseObj} userObj={userObj} updatedList={updatedList} fullList={true} ref={childRefSaveNew} /> */}
			{/* <LeadSaveEdit dataObj={caseObj} userObj={userObj} updatedList={updatedList} fullList={true} ref={childRefSaveEdit}  /> */}
			<LeadDetails leadId={(caseObj && caseObj.relatedToId>0)?caseObj.relatedToId:null} privileges={privileges} userObj={userObj} ref={childRefCaseDetails}  />						
			<AccountDetails accountId={(caseObj && caseObj.relatedToId>0)?caseObj.relatedToId:null} userObj={userObj} closebtn={true} ref={childRefAccntDetails} />						

				<Stack spacing={2} sx={{ width: '100%' }}>
					<Snackbar open={showAlert} autoHideDuration={6000} onClose={hideAlert} anchorOrigin={{vertical,horizontal}}  >
						<Alert onClose={hideAlert} variant="filled" severity={severityAlert} sx={{ width: '100%' }}>
							{alertMessage}
						</Alert>
					</Snackbar>
				</Stack>

				<Dialog
					open={deleteDialogShow}
					onClose={deleteDialogHide}
					aria-labelledby="alert-dialog-section-title"
					aria-describedby="alert-dialog-section-description"
				>
					<DialogTitle id="alert-dialog-section-title">
						Alert
					</DialogTitle>
					<DialogContent>
					<DialogContentText id="alert-dialog-section-description">
						Are you sure, You want to delete.
					</DialogContentText>
					</DialogContent>
					<DialogActions>
					<Button variant="outlined" size="small" onClick={()=>{deleteDialogHide()}}>Don't Delete</Button>
					<Button variant="contained" size="small" color="secondary" onClick={()=>{deleteData()}} autoFocus>Yes, Delete</Button>
					</DialogActions>
				</Dialog>

			<Authorization ref={childRefAuthorization} />		
			
		</div>	
	);
  }